import { render, staticRenderFns } from "./paymethod.vue?vue&type=template&id=6a0e770e&scoped=true&"
import script from "./paymethod.vue?vue&type=script&lang=js&"
export * from "./paymethod.vue?vue&type=script&lang=js&"
import style0 from "./paymethod.vue?vue&type=style&index=0&id=6a0e770e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e770e",
  null
  
)

export default component.exports